import React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Price } from '@partsbadger/library';
import { PricesByQuantity } from '@partsbadger/types';

interface Props {
    item: PricesByQuantity;
}

const QuoteLineQuantityItem = (props: Props) => {
    const { item } = props;

    return (
        <div className={'flex flex-row'}>
            <div className={'flex flex-row w-full'}>
                <div className={'w-1/4 mr-4'}>
                    <div className={'flex justify-center'}>{item.quantity}</div>
                </div>

                <div className={'w-1/4 mr-4'}>
                    <div className={'flex justify-center'}>{item.lead_time} days</div>
                </div>

                <div className={'w-1/4 mr-4'}>
                    <div className={'flex justify-center'}>
                        {item.safe_auto_quote ? <Price value={item.unit_price} /> : 'Need Review'}
                    </div>
                </div>

                <div className={'w-1/4 mr-4'}>
                    <div className={'flex justify-center'}>
                        {item.safe_auto_quote ? <Price value={item.total_price} /> : 'Need review'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteLineQuantityItem;
